import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { appState } from '../../../../constants/app-state';
import { Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'arm-message-file',
  templateUrl: './message-file.component.html',
  styleUrls: ['./message-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageFileComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription = new Subscription();

  public validSubscription: any = new Subject();
  public buttonDisablePrivate: boolean;

  constructor(private router: Router,
              private cd: ChangeDetectorRef) {

  }

  set buttonDisable(value: boolean) {
    this.buttonDisablePrivate = value;
    this.cd.detectChanges();
  }

  get buttonDisable(): boolean {
    return this.buttonDisablePrivate;
  }

  public nextStep(): void {
    this.router.navigate(['management-company/chats/message-building']);
  }

  public ngOnInit(): void {

    appState.getValue().progressBar.next({
      show: true,
      value: 100 / 4 * 3,
    });

    this.subscriptions.add(
      this.validSubscription
        .subscribe((value: boolean) => {
          this.buttonDisable = value;
        })
    );
  }

  public ngOnDestroy(): void {
    appState.getValue().progressBar.next({
      show: false,
      value: 0,
    });

    this.subscriptions.unsubscribe();
  }
}
